module.exports = __webpack_public_path__ + "static/media/ONYX_GRECO.d08b7705.jpg";